<template>
    <div class="c-event__meta">
        <template v-if="royal_event">
            <div class="c-event__park is-royal"><i class="fa-solid fa-location-dot"></i> The Royal</div>
        </template>

        <NuxtLink
            v-if="park && !royal_event"
            class="c-event__park"
            noPrefetch
            :to="stripBaseUrl(park_details.landing_page)">
            <i class="fa-solid fa-location-dot"></i>
            <span v-html="park.post_title"></span>
        </NuxtLink>

        <div v-if="date || time" class="c-event__date">
            <template v-if="date">{{ date }}</template>
            <span v-if="time">{{ time }}</span>
        </div>

        <NuxtLink class="c-event__more-events" noPrefetch to="/events/">More events</NuxtLink>

        <NuxtLink v-if="additional_link" class="c-event__additional-link" noPrefetch :to="additional_link.url">
            <span v-html="additional_link.title"></span>
        </NuxtLink>

        <NuxtLink
            v-if="park && enable_book_stay_button"
            class="c-event__book-stay"
            noPrefetch
            :to="stripBaseUrl(park_details.landing_page)">
            Book a stay at this park
        </NuxtLink>
    </div>
</template>

<script setup>
    const props = defineProps({
        additional_link: {
            type: Object,
            required: false,
        },
        date: {
            type: String,
            required: false,
        },
        enable_book_stay_button: {
            type: Boolean,
            required: false,
        },
        royal_event: {
            type: Boolean,
            required: false,
        },
        park: {
            type: Object,
            required: false,
        },
        time: {
            type: String,
            required: false,
        },
    });

    const park_details = ref(null);

    function stripBaseUrl(url) {
        if(!url) {
            return;
        }
        return url.replace(/^https?:\/\/[^/]+/, "");
    }

    if (props.park) {
        const getPark = async (park) => {
            // console.log(park);

            const { data } = await useFetch(`/api/wp/event/park/${park}`);

            park_details.value = data.value;
        };
        await getPark(props.park.ID);

        // console.log("Park: ", park_details.value);
    }
</script>
